<template>
    <div class="betslip__user-balance">
        <i class="icon icon-wallet"/>
        <div class="betslip__user-balance-amount">
            <div class="label">
                <span> {{ `${$t('real')} ${$t('currencyAbbreviation')}` }} </span>
            </diV>
            <div class="amount">
                <span>{{ userBalance  | currency }}</span>
            </div>
        </div>
        <div class="betslip__user-balance-bonus-amount">
            <div class="label">
                <span> {{ `${$t('bonus')} ${$t('currencyAbbreviation')}` }} </span>
            </div>
            <div class="amount">
                <span>{{ userBonus  | currency }}</span>
            </div>
        </div>
        <router-link
            :to="{ name: routeNames.deposit }"
            tag="button"
            class="btn btn--md btn__primary--yellow"
        >
            {{ $t('deposit') | capitalize }} <i icon="icon icon-chevron_right"/>
        </router-link>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { routeNames } from '@app/router';

    export default {
        name: 'UserBalance',
        created() {
            this.routeNames = routeNames;
        },
        computed: {
            ...mapGetters('data/authentication', [
                'userBalance',
                'userBonus',
            ]),
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/UserBalance.vue